<template>
  <div id="callWay">
    <div class="callWayCont">
      <div class="_callWayCont">
        <div class="title">
          <p>联系方式</p>
        </div>
        <!-- <div class="cont">
          <p>公司：杭州首秀网络科技有限公司</p>
          <p>地址：浙江省杭州市西湖区莲花街333号莲花商务中心北楼6层611室-2</p>
          <p>邮编：450001</p>
          <p>邮箱：superadmin@shangnide.com</p>
          <p>客服QQ：3413217598</p>
        </div> -->
        <div class="cont">
          <p>公司：杭州缘分网络科技有限公司</p>
          <p>地址：浙江省杭州市西湖区莲花街333号莲花商务中心北楼6层611 室-3</p>
          <p>邮编：450001</p>
          <p>邮箱：superadmin@shangnide.com</p>
          <p>客服QQ：3413217598</p>
        </div>
        <div class="map">
          <img src="../assets/map.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  #callWay{
    background: #F5F6F8;padding-top: 24px;padding-bottom: 100px;
    .callWayCont{
      width: 1000px;background: #fff;padding-top: 41px;padding-bottom: 100px;
      margin: 0 auto;
      ._callWayCont{
        .title{
          text-align: center;font-size: 24px;line-height: 33px;margin-bottom: 40px;
        }
        .cont{
          margin-bottom: 24px;padding-left: 158px;
          p{
            font-size: 16px;line-height: 20px;color: #666;
          }
        }
        .map{
          padding-left: 158px;
          img{
            display: block;width: 680px;
          }
        }
      }
    }
  }
</style>

<script>
export default {
  name:'callWay',
  components:{},
  data(){
    return{

    }
  },
  methods:{

  },
  created(){
    this.$myStore.setMessageAction(3);
  },
  mounted(){
    
  }
}
</script>